<template>
<div>
	<div v-if="socket && inProgress">
		<FullView
			:videoCallData="videoCallData"
			v-if="fullView"
			:calledUserID="calledUserID"
			:deviceID="deviceID"
			:atencionID="atencionID"
			:socket="socket"
			:usersInRoom="usersInRoom"
			:localStream="localStream"
			:remoteCalledStream="remoteCalledStream"
			:remoteStreams="remoteStreams"
			:endVideoCallCallback="endVideoCall"
			:goPicInPicCallback="goPicInPic"
			:socketRoom="socketRoom"
			:destroyConnectionWithRemote="destroyConnectionWithRemote"
		/>
<!-- 		<PipView
			v-else
			:remoteCalledStream="remoteCalledStream"
			:remoteStreams="remoteStreams"
			:localStream="localStream"
			:usersInRoom="usersInRoom"
			:endVideoCallCallback="endVideoCall"
			:goFullScreenCallback="goFullScreen"
			:socketRoom="socketRoom"
		/> -->
	</div>
	<div v-else>
	  <div v-show="true" style="height: 100vh; width: 100vw; display:flex; justify-content:center; align-items: center; gap: 12px;  position: absolute; z-index: 1;
    background: #FFF;">
				Por favor espera unos segundos mientras iniciamos la videollamada
			<div class="loader"></div> 
	  </div>
	</div>
</div>
</template>

<script>
/* import * as firebase from 'firebase/app'
import 'firebase/database' */
	// Necesito pasarle socketURL,  socketRoom, calledUserID, deviceID
	import FullView from './FullView'
/* 	import PipView from './PipView' */
	import {joinUserVideoCall, leftUserVideoCall} from '../../helpers/api/horas_medicas'
	import kurentoUtils from 'kurento-utils'
	import io from 'socket.io-client'
/* import { useStore } from '../../store/store';
      const store = useStore()
 */
	export default {
	  name: 'VideoCallRoom',
	  components: {FullView, /* PipView */},
	  props: ['videoCallData', 'userData'],
	  data(){
	    return {
	    	fullView: true,
	    	inProgress: false,
	    	localWebRtcPeer: null,
	    	localStream: null,
	    	remotesWebRtcPeer: {},
	    	remoteStreams: [],
	    	remoteCalledStream: null,
	    	usersInRoom: {},
	    	roomID: null,
    		socket: null,
    		recording: false,
    		atencionID: this.videoCallData.attention_id,
    		deviceID: null,
    		calledUserID: null,
    		socketUrl: null,
    		socketRoom: null,
    		hideVideo: false,
    		silent: true,
    		readyForConnection: false,
    		alertID: null,
				geoUserAlert: null,
				setVideoFlowingTimeout: null,
				turnServer: null,
				audioInputDevice: 'default'
	    }
	  },
/* 	  computed: {
		...mapState(['audioInputDevice'])
	  }, */
	  mounted(){
	  	const videoCallData = this.videoCallData
/* 		localStorage.setItem('videocallInProgress', videoCallData.videocallID) */
/* 	  	this.deviceID = videoCallData.deviceID */
			this.socketUrl = this.videoCallData.socket_url
			this.socketRoom = this.videoCallData.socket_room
			this.startConnection()
/* 			this.calledUserID = videoCallData.profile.user_id */
/* 			this.videocallID = videoCallData.id */
/* 			this.fullView = videoCallData.fullView
			this.hideVideo = videoCallData.hideVideo
			this.silent = videoCallData.silent
      this.alertID = videoCallData.alert_id
      this.geoUserAlert = videoCallData.geo_usuario */

/* 			this.createRoomAndStart() */
			navigator.connection.onchange = this.changeHandler

	  },
	  methods: {
	  	changeHandler(event){
	  		console.log(event)
	  	},
	  	async createRoomAndStart(tries = 0){
		    if(this.socketUrl && this.socketRoom && this.videocallID){
		    	this.readyForConnection = true
	    		this.startConnection()
				try {
					await initVideoCallWithDevice({
					  to_users: [ this.calledUserID ],
					  device_id: this.deviceID,
					  videocall_id: this.videocallID,
					  socket_room: this.socketRoom,
					  socket_url: this.socketUrl,
					  silent: this.silent,
					  hideVideo: this.hideVideo,
					})
				} catch (error) {
				this.$store.commit("setVideoCallData", {
      				status: false,
      				alertID: null,
      				geoUserAlert: null,
      				fullView: true,
      				deviceID: null,
      				calledUserID: null,
      				socketUrl: null,
      				socketRoom: null,
      				videocallID: null,
      				hideVideo: false,
      				silent: true,
    			},)
			}
	      }
	  	},
	  	goPicInPic() {
	  		this.fullView = false
	  	},
	  	goFullScreen(){
	  		this.fullView = true
	  	},
			setVideoFlowingCountDown(){
				this.setVideoFlowingTimeout = setTimeout(() => {
					this.reloadConnection()
				}, 7000);
			},
	  	async startConnection(){
		    this.socket = io(this.socketUrl,
			    {
			      transports: ['websocket'],
			      autoConnect: false,
			      reconnect: true,
			      forceNew: true
			    })
				this.setSocketListeners()
				this.startVideoCall()
				this.inProgress = true

				
				const data = {user_id: this.userData.id, attention_id: this.videoCallData.attention_id}
				joinUserVideoCall(data).then(res => {
					console.log(res);
				})

/* 	      const atencion = await startAtencion({callee_id: this.calledUserID, videocall_id: this.videocallID}) */
/* 	      if(atencion.code === 200){
	        this.atencionID = atencion.atencion.id
	      } */
			},
			setSocketListeners(){
				this.socket.on('message', (data) => {
/* 					console.log(data, '<====================='); */
				  switch (data.id) {
				    case 'startResponse':
				      this.startResponse(data.sdpAnswer);
				      break;
				    case 'remoteResponse':
				      this.remoteResponse(data.remoteSocketID, data.sdpAnswer);
				      break;
				    case 'error':
				      console.log('Error message from server: ' + data.message);
				      break;
				    case 'iceCandidate':
				      this.localWebRtcPeer.addIceCandidate(data.candidate)
				      break;
				    case 'remoteIceCandidate':
				    	this.remotesWebRtcPeer[data.remoteSocketID].addIceCandidate(data.candidate)
				      break;
				    case 'usersInRoom':
				      this.createMultipleNewEndpoints(data.usersInRoom)
				      break;
				    case 'inRoomUserChange':
				      this.inRoomUserChange(data)
				      break;
				    case 'newUserInRoom':
				      this.createNewEndpoint(data.user)
				      break;
				    case 'userLeaveRoom':
				      this.destroyConnectionWithRemote(data.socketID)
				      break;
				    case 'startRecording':
				      this.recording = true
				      break;
				    case 'stopRecording':
				      this.recording = false
				      break;
				    case 'roomStats':
				      // this.handleRoomStats(data.stats)
				      break;
				    case 'videoStats':
				    	// console.log('videoStats', data.stats)
				      // handleVideoStats(data.stats)
				      break;
				    case 'mediaFlowStateChange':

							if(data.flowStatus.type == "MediaFlowOutStateChange" && data.flowStatus.state == "FLOWING" && data.flowStatus.mediaType == "VIDEO"){
								this.startSmartbandConnection()

								//Empieza a grabar video operador
								const message = {id: 'startRecording'}
								this.socket.emit('message', message)
							}
				    	console.log('mediaFlowStateChange', data)
				      break;
				    default:
				      console.log('Unrecognized message: ', data);
			  	}
			  })
			},
			startVideoCall(){
				const name = this.userData.name
				const userID = this.userData.id
				this.join(this.socketRoom, name, userID, true)

			},
			endVideoCall(){
			  this.socket.close()
			  this.localWebRtcPeer.dispose()
			  Object.keys(this.remotesWebRtcPeer).forEach((key) => {
			    this.remotesWebRtcPeer[key].dispose()
			  })
/* 				if(this.atencionID){
					leftUserVideoCall({atencion_id: this.atencionID}).then(res => {
					})
				} */
			this.cleanRoom()
			this.$router.push('/reserva')
/* 				this.deleteFromRTDB() */
/* 
				//limpia listener medición
				firebase.database(this.$store.state.primaryDB).ref('Iduam/Mediciones/' + this.calledUserID).remove()

				let notes = JSON.parse(localStorage.getItem('notes'))
          		localStorage.setItem('notes', JSON.stringify(notes.filter(obj => obj.atencion_id !== this.atencionID)))
				this.$events.fire('clearIntervalNote') */
			},
/* 			deleteFromRTDB(){
				this.videocallID
				firebase.database(this.$store.state.primaryDB).ref('/SOSclick/Denuncias/' + this.videocallID).remove()
			}, */
	  	hideRemoteVideo(socketID){
	  		const message = {
	  			id: 'admin-actionMessage',
	  			action: 'admin-ToggleVideo',
	  			to: socketID,
	  			status: false
	  		}
			  this.sendMessage(message)
	  	},
	  	startSmartbandConnection(){
				if(this.remoteCalledStream){
					const message = {
						id: 'admin-actionMessage',
						action: 'admin-startSmartbandConnection',
						to: this.remoteCalledStream.socketID
					}
					this.sendMessage(message)
				}
	  	},
	  	stopSmartbandConnection(){
				if(this.remoteCalledStream){
					const message = {
						id: 'admin-actionMessage',
						action: 'admin-stopSmartbandConnection',
						to: this.remoteCalledStream.socketID
					}
					this.sendMessage(message)
				}
	  	},
			cleanRoom(){
	    	this.fullView = true
	    	this.inProgress = false
	    	this.localWebRtcPeer = null
	    	this.localStream = null
	    	this.remotesWebRtcPeer = {}
	    	this.remoteStreams = []
	    	this.remoteCalledStream = null
	    	this.usersInRoom = {}
	    	this.roomID = null
    		this.socket = null
    		this.recording = false
    		this.atencionID = null
    		this.deviceID = null
    		this.calledUserID = null
    		this.socketUrl = null
    		this.socketRoom = null
    		this.hideVideo = false
    		this.readyForConnection = false
    		this.turnServer = null
        this.$store.commit("setVideoCallData", {
		      status: false,
      		alertID: null,
          geoUserAlert: null,
		      fullView: true,
		      deviceID: null,
		      calledUserID: null,
		      socketUrl: null,
		      socketRoom: null,
		      videocallID: null,
		      hideVideo: false,
		      silent: true
		    })
			},
			join(roomName, userName, userID, isAdmin) {
			  this.socket.connect()
			  this.socket.emit('join', {roomName, userName, userID, isAdmin, fromApp: 'iduam'}, response => {
			  	console.log("Resonse: ", response, '_____________')
			  	this.addUserToRoom(response, true)
			  	this.turnServer = {
			  		turn_ip: response.turn_ip,
						turn_port: response.turn_port,
						turn_user: response.turn_user,
						turn_password: response.turn_password,
					}
			  	this.startComunnications(userName)
			  })
			},
	  	startComunnications(userName) {
			  var options = {
	    		onaddstream: (event) => { this.onAddLocalStream() },
	    		onicecandidate: (candidate) => this.onIceCandidate(candidate),
			    configuration: {
			      iceServers: [{
			        "urls":"turn:" + this.turnServer.turn_ip + ":" + this.turnServer.turn_port,
			        "username":this.turnServer.turn_user,
			        "credential":this.turnServer.turn_password,
			      }]
			    },
			    mediaConstraints: {
			      audio: {
					deviceId: 'default'
				  },
			      video: {
		        	width: { min: 640, ideal: 1280, max: 1920 },
		        	height: { min: 480, ideal: 720, max: 1080 },	
			      }
			    }
			  }
			  const self = this
			  this.localWebRtcPeer = kurentoUtils.WebRtcPeer.WebRtcPeerSendonly(options, function(error) {
			    if(error) return console.log(error)
					self.localStream = this.getLocalStream()
			    this.generateOffer((error, offerSdp) => self.onOffer(error, offerSdp))
			  });
			},
			onAddLocalStream(){
				this.localStream = this.localWebRtcPeer.getLocalStream()
			},
			onOffer(error, offerSdp) {
			  if(error) return console.log("error: ", error);
			  const message = {
			    id : 'start',
			    sdpOffer : offerSdp
			  }
			  this.sendMessage(message)
			},
			sendMessage(message){
				this.socket.emit('message', message)
			},
			onIceCandidate(candidate) {
			  var message = {
			    id : 'onIceCandidate',
			    candidate : candidate
			  }
			  this.sendMessage(message)
			},
			startResponse(sdpAnswer) {
			  this.localWebRtcPeer.processAnswer(sdpAnswer)
			},
			remoteResponse(remoteSocketID, sdpAnswer) {
			  this.remotesWebRtcPeer[remoteSocketID].processAnswer(sdpAnswer)
			},
			addUserToRoom(user, local = false){
			  const usersInRoom = Object.assign({}, this.usersInRoom)
			  user.local = local
			  usersInRoom[user.socketID] = user
			  this.usersInRoom = usersInRoom
			},
			inRoomUserChange(user){
				const userInfo = user.user
			  let usersInRoom = Object.assign({}, this.usersInRoom)
			  if(usersInRoom[user.socketID]){
			  	usersInRoom[user.socketID] = Object.assign(usersInRoom[user.socketID], userInfo)
			  	this.usersInRoom = usersInRoom
			  }
				
				const isLocal = this.usersInRoom && this.usersInRoom[userInfo.socketID] && this.usersInRoom[userInfo.socketID].local
				if(!isLocal){
					this.remoteCalledStream = {
						...userInfo,
						...this.remoteCalledStream
					}
					this.startSmartbandConnection()
				}
			},
			createMultipleNewEndpoints(usersInRoom){
			  usersInRoom.map((user) => {
			    this.createNewEndpoint(user)
			  })
			},
			createNewEndpoint(user){
			  const {socketID} = user
			  var options = {
    			// remoteVideo: video,
			    configuration: {
			      iceServers: [{
			        "urls":"turn:" + this.turnServer.turn_ip + ":" + this.turnServer.turn_port,
			        "username":this.turnServer.turn_user,
			        "credential":this.turnServer.turn_password,
			      }]
			    },
			    onicecandidate: (candidate) => { this.onIceCandidateRemote(candidate, socketID) },
	    		onaddstream: (event) => { this.onAddRemoteStream(user) }
			  }
			  const self = this
			  this.addUserToRoom(user)
			  this.remotesWebRtcPeer[socketID] = kurentoUtils.WebRtcPeer.WebRtcPeerRecvonly(options, function(error) {
			    if(error) return false
			    this.generateOffer( (error, offer) => { self.onRemoteOffer(error, offer, socketID) } )
			  });
			},
			onAddRemoteStream(user){
				const remoteStream = this.remotesWebRtcPeer[user.socketID].getRemoteStream()
				// this.remoteCalledStream = {
				// 	...user,
				// 	stream: remoteStream
				// }
				const isLocal = this.usersInRoom && this.usersInRoom[user.socketID] && this.usersInRoom[user.socketID].local
				if(!isLocal){
					this.remoteCalledStream = {
						...user,
						stream: remoteStream
					} 
/* 					this.startSmartbandConnection() */
					// if(this.hideVideo){this.hideRemoteVideo(user.socketID)}

					//start recording
/* 					setTimeout(() => {
						const message = {
	  						id: 'admin-actionMessage',
	  						action: 'admin-startRecord',
	  						to: user.socketID,
	  						status: this.userVideo
	  					}
						this.socket.emit('message', message)
					}, 1000); */
					
				}
				else{
					let remoteStreams = [...this.remoteStreams]
					remoteStreams.push({
						...user,
						stream: remoteStream
					})
					this.remoteStreams = remoteStreams
				}
			},
			onIceCandidateRemote(candidate, socketID) {
			  const message = {
			    id : 'onIceCandidateRemote',
			    socketID,
			    candidate : candidate
			  };
			  this.sendMessage(message)
			},
			onRemoteOffer(error, offerSdp, socketID) {
			  if(error) return false
			  const message = {
			    id : 'newRemoteOffer',
			    socketID,
			    sdpOffer : offerSdp
			  }
			  this.sendMessage(message)
			},
			destroyConnectionWithRemote(socketID){
				if(this.remotesWebRtcPeer[socketID]){
			  	this.remotesWebRtcPeer[socketID].dispose()
			  	delete this.remotesWebRtcPeer[socketID]
			  }
			  const remoteStreamIndex = this.remoteStreams.findIndex((item) => {
			  	return item.socketID = socketID
	  		  })
			  if(remoteStreamIndex !== -1){
					let remoteStreams = [...this.remoteStreams]
			  	remoteStreams.splice(remoteStreamIndex, 1)
					this.remoteStreams = remoteStreams
			  }
			  const userInfo = this.usersInRoom[socketID]
		  	delete this.usersInRoom[socketID]
				if(this.calledUserID === userInfo.userID){
					this.remoteCalledStream = null
				}
			},
			switchAudioInput() {
				const pc = this.localWebRtcPeer.peerConnection;

				navigator.mediaDevices.getUserMedia({
			      audio: {
					deviceId: 'default'
				  },
			      video: {
		        	width: { min: 640, ideal: 1280, max: 1920 },
		        	height: { min: 480, ideal: 720, max: 1080 },	
			      }
    			})
    			.then((stream) => {
    			  const [MediaStreamTrack] = stream.getAudioTracks();
    			    const sender = pc.getSenders().find((s) => s.track.kind === MediaStreamTrack.kind);
					  sender.replaceTrack(MediaStreamTrack);
    			  })
    			.catch((err) => {
    			  console.error(`Error happened: ${err}`);
    			});
			}
	  },
	watch: {
    	 'audioInputDevice': function (val) {
      		this.switchAudioInput()
    	},
	}
}
</script>
<style lang="scss">

.loader {
  width: 60px;
  aspect-ratio: 2;
  --_g: no-repeat radial-gradient(circle closest-side,#000 90%,#0000);
  background: 
    var(--_g) 0%   50%,
    var(--_g) 50%  50%,
    var(--_g) 100% 50%;
  background-size: calc(100%/3) 50%;
  animation: l3 1s infinite linear;
}
@keyframes l3 {
    20%{background-position:0%   0%, 50%  50%,100%  50%}
    40%{background-position:0% 100%, 50%   0%,100%  50%}
    60%{background-position:0%  50%, 50% 100%,100%   0%}
    80%{background-position:0%  50%, 50%  50%,100% 100%}
}
</style>